export default "__VITE_ASSET__3166c096__"